(function () {
    'use strict';

    angular.module('traitsetApplication', ['ngAnimate', 'angular-loading-bar', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'ui.bootstrap', 'toastr', 'ngStorage', 'ui.mask']);

    angular.element(document).ready(
        function () {
            var initInjector = angular.injector(['ng']);
            var $http = initInjector.get('$http');
            var $log = initInjector.get('$log');
            var $window = initInjector.get('$window');
            var language = $window.localStorage.getItem('language');

            $http.get('/api/c.php?language='+language)
                .then(
                    function (response) {
                        angular.module('traitsetApplication').constant('BookInfo', response.data);

                        angular.bootstrap(document, ['traitsetApplication']);
                    })
                .catch(
                    function () {
                        $log.debug('Running in Error State. Loading Default Config.');
                        // $http.get('http://96.126.117.97/api/c.php').then(
                        $http.get('https://abc321.traitset.com/api/c.php?language='+language).then(
                            function (response) {
                                angular.module('traitsetApplication').constant('BookInfo', response.data);

                                angular.bootstrap(document, ['traitsetApplication']);
                            })
                    }
                );
        }
    );
})();




(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .directive('navHeader', navHeader);

    /** @ngInject */
    function navHeader() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navheader/navheader.html',
            scope: {
                creationDate: '='
            },
            controller: NavHeaderController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavHeaderController(BookInfo, $window) {
            var vm = this;

            vm.CompanyName = BookInfo.BookDetails.CompanyName;
            vm.ExpImage = BookInfo.Style.BaseStyle.ExpImage;

            vm.newLanguage = newLanguage;

            if($window.localStorage.getItem('language')) {
                vm.languageOption = $window.localStorage.getItem('language');
            }

            function newLanguage(language) {
                $window.localStorage.setItem('language', language);
                console.log('NewLanguage');
                console.log(language);
                $window.location.reload(true);
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .directive('navFooter', navFooter);

    /** @ngInject */
    function navFooter() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navfooter/navfooter.php',
            scope: {
                creationDate: '='
            },
            controller: NavFooterController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavFooterController() {

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .factory('testtakerApi', testtakerApi);

    /** @ngInject */
    function testtakerApi($http, $log, Config, $window) {

        var service = {
            createTestTaker: createTestTaker,
            updateTestTaker: updateTestTaker,
            getTestTakerByPin: getTestTakerByPin
        };

        return service;

        function createTestTaker(testTakerValues) {
            return $http.post(Config.apiUrl + '/testtaker/', testTakerValues)
                .then(function (response) {
                    return response;
                });
        }

        function updateTestTaker(UserPin, testTakerValues) {
            return $http.put(Config.apiUrl + '/testtaker/'+UserPin, testTakerValues)
                .then(function (response) {
                    return response;
                });
        }

        function getTestTakerByPin(UserPin) {
            return $http.get(Config.apiUrl + '/testtaker/'+UserPin+'?language='+$window.localStorage.getItem('language'))
                .then(function (response) {
                    return response;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .factory('questionsApi', questionsApi);

    /** @ngInject */
    function questionsApi($http, $log, Config, $window) {

        var service = {
            getQuestionsByPin: getQuestionsByPin,
            saveTestAnswers: saveTestAnswers,
            goBack: goBack
        };

        return service;

        function getQuestionsByPin(UserPin) {
            return $http.get(Config.apiUrl + '/questions/'+UserPin+'?language='+$window.localStorage.getItem('language'))
                .then(function (response) {
                    return response;
                });
        }

        function goBack(UserPin, dataObj) {
            return $http.put(Config.apiUrl + '/questions/'+UserPin, dataObj)
                .then(function (response) {
                    return response;
                });
        }

        function saveTestAnswers(UserPin, questionsObj) {
            return $http.post(Config.apiUrl + '/questions/'+UserPin, questionsObj)
                .then(function (response) {
                    return response;
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .factory('postingPageApi', postingPageApi);

    /** @ngInject */
    function postingPageApi($http, $log, Config, $window) {
        var service = {
            getPostingsByLocationBook: getPostingsByLocationBook
        };

        return service;

        function getPostingsByLocationBook(Location, NoBook, NoPosition) {

            return $http.get(Config.apiUrl + '/posting_list/'+Location+'?noBook='+NoBook+'&noPosition='+NoPosition+'&language='+$window.localStorage.getItem('language'))
                .then(function (response) {
                    return response;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .factory('postingDetailApi', postingDetailApi);

    /** @ngInject */
    function postingDetailApi($http, $log, Config, $window) {
        var service = {
            getPostedPositionByNo: getPostedPositionByNo
        };

        return service;

        function getPostedPositionByNo(NoPosition) {

            return $http.get(Config.apiUrl + '/posting_detail/'+NoPosition+'?language='+$window.localStorage.getItem('language'))
                .then(function (response) {
                    return response;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .factory('positionsApi', positionsApi);

    /** @ngInject */
    function positionsApi($http, $log, Config, $window) {

        var service = {
            getPositionByCourseId: getPositionByCourseId,
            getPositionByPositionId: getPositionByPositionId
        };

        return service;

        function getPositionByCourseId(courseId) {

            return $http.get(Config.apiUrl + '/positions/'+courseId+'?language='+$window.localStorage.getItem('language'))
                .then(function (response) {
                    return response;
                });
        }

        function getPositionByPositionId(courseId, positionId) {

            return $http.get(Config.apiUrl + '/sub_positions/'+positionId+'?course='+courseId+'&language='+$window.localStorage.getItem('language') )
                .then(function (response) {
                    return response;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .factory('locationsApi', locationsApi);

    /** @ngInject */
    function locationsApi($http, $log, Config, $window) {
        var service = {
            getBookById: getBookById
        };

        return service;

        function getBookById(bookId) {

            return $http.get(Config.apiUrl + '/book_info/'+bookId+'?language='+$window.localStorage.getItem('language'))
                .then(function (response) {
                    return response;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .factory('locationFinderApi', locationFinderApi);

    /** @ngInject */
    function locationFinderApi($http, $log, Config, $window) {
        var service = {
            getByZipCodeRadius: getByZipCodeRadius
        };

        return service;

        function getByZipCodeRadius(zipCode, radius, NoBook) {

            return $http.get(Config.apiUrl + '/location_finder/'+zipCode+'?radius='+radius+'&NoBook='+NoBook+'&language='+$window.localStorage.getItem('language'))
                .then(function (response) {
                    return response;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .factory('eventsApi', eventsApi);

    /** @ngInject */
    function eventsApi($http, $window) {
        var apiUrl = 'https://dowser.io/api';

        var service = {
            searchEvents: searchEvents
        };

        return service;

        function searchEvents(searchString) {
            return $http.get(apiUrl + '/events/'+searchString+'?language='+$window.localStorage.getItem('language'))
                .then(function (response) {
                    return response;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('SampleColorsController', SampleColorsController);

    /** @ngInject */
    function SampleColorsController($log, BookInfo) {
        $log.debug('Loaded: SampleColorsController');

        var vm = this;

        vm.BookInfo = BookInfo;

        vm.dechex = dechex;

        function dechex(d) {
            var number = (+d).toString(16).toUpperCase();

            if(number.length === 6) {
                return number;
            } else {
                return 0;
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('ProcessController', ProcessController);

    /** @ngInject */
    function ProcessController($log) {
        $log.debug('Loaded: ProcessController');

    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('PostingPageController', PostingPageController);

    /** @ngInject */
    function PostingPageController($log, $stateParams, postingPageObj, $window) {
        $log.debug('Loaded: PostingPageController');
        $log.debug(postingPageObj);

        var r = $stateParams.r;
        if(r) { $window.localStorage.setItem('source', r); }

        var vm = this;

        vm.error = postingPageObj.data.Error;
        vm.errorStr = postingPageObj.data.ErrorStr;
        vm.BookName = postingPageObj.data.BookDetails.BookName;
        vm.Positions = postingPageObj.data.Listings;
        vm.Phrases = postingPageObj.data.Phrases;
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('PostingDetailController', PostingDetailController);

    /** @ngInject */
    function PostingDetailController($log, $stateParams, postingDetailObj, $window) {
        var r = $stateParams.r;
        if(r) { $window.localStorage.setItem('source', r); }

        $log.debug('Loaded: PostedPositionController');
        $log.debug(postingDetailObj);

        var vm = this;

        vm.NoPosition = postingDetailObj.data.PositionDetails.PositionDetails.Position;
        vm.NoCourse = postingDetailObj.data.PositionDetails.PositionDetails.NoCourse;

        vm.position = postingDetailObj.data.PositionDetails;
        vm.Phrases = postingDetailObj.data.Phrases;

    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('LocationFinderController', LocationFinderController);

    /** @ngInject */
    function LocationFinderController($log, $state, BookInfo, $filter, Session, locationFinderApi, $sce) {
        $log.debug('Loaded: LocationFinderController');

        var vm = this;

        vm.radius = '25';

        vm.locationFormText = BookInfo.BookDetails.LocationFormfull;
        vm.locationResultsText = $sce.trustAsHtml(BookInfo.BookDetails.LocationResultsfull);

        vm.NoBook = BookInfo.BookDetails.NoBook;
        vm.BookId = '_'+BookInfo.BookDetails.BookId;

        console.log(vm.BookId);

        vm.submitForm = submitForm;

        function submitForm() {
            $log.debug(vm);
            vm.results = '';
            vm.error = '';

            //vm.loading = 1;

            locationFinderApi.getByZipCodeRadius(vm.zipCode, vm.radius, BookInfo.BookDetails.NoBook)
                .then(function (results) {
                    vm.results = 1;
                    vm.locations= results.data.Locations;
                    $log.debug(results);
                    vm.loading = 0;
                })
                .catch(function (error) {
                    vm.error = '1';
                    vm.errorStr = 'No locations found. Please try a new zip code or search a larger area.';
                    $log.debug('Error Submitting Form');
                    $log.debug(error);
                    vm.loading = 0;
                });
        }
    }
})();

angular
    .module('traitsetApplication')
    .factory('Session', Session);

/** @ngInject */
function Session() {
    var storage = sessionStorage;

    var service = {
        get: get,
        set: set,
        unset: unset
    };

    return service;

    function get(key) {
        return storage.getItem(key);
    }

    function set(key, val) {
        storage.setItem(key, val);
    }

    function unset(key) {
        storage.removeItem(key);
    }
}

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .filter('nl2br', nl2br);

    /** @ngInject */
    function nl2br($sce) {
        return function (msg, is_xhtml) {
            is_xhtml = is_xhtml || true;
            var breakTag = (is_xhtml) ? '<br />' : '<br>';
            msg = (msg + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            return $sce.trustAsHtml(msg);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .directive('limitTo', limitTo);

    /** @ngInject */
    function limitTo() {
        return {
            restrict: "A",
            link: function (scope, elem, attrs) {
                var limit = parseInt(attrs.limitTo);
                angular.element(elem).on("keypress", function (e) {
                    if (this.value.length == limit) e.preventDefault();
                });
            }
        }
    }
})();
/*app.directive('formatPhone', [
    function() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function(scope, elem, attrs, ctrl, ngModel) {
                elem.add(phonenumber).on('keyup', function() {
                    var origVal = elem.val().replace(/[^\w\s]/gi, '');
                    if(origVal.length === 10) {
                        var str = origVal.replace(/(.{3})/g,"$1-");
                        var phone = str.slice(0, -2) + str.slice(-1);
                        jQuery("#phonenumber").val(phone);
                    }

                });
            }
        };
    }
]);*/
/*
(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .directive('formatPhone', formatPhone);

    function formatPhone() {
        return {
            require: 'ngModel',
            restrict: "A",
            link: function(scope, elem, attrs, ctrl, ngModel) {
                elem.add(phonenumber).on('keyup', function() {
                    var origVal = elem.val().replace(/[^\w\s]/gi, '');
                    if(origVal.length === 10) {
                        var str = origVal.replace(/(.{3})/g,"$1-");
                        var phone = str.slice(0, -2) + str.slice(-1);
                        jQuery("#phonenumber").val(phone);
                    }

                });
            }
        }
    }
})();  */
(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('ExitReviewController', ExitReviewController);

    /** @ngInject */
    function ExitReviewController($log, applicationObj, $state) {
        $log.debug('Loaded: ExitReviewController');
        var vm = this;

        vm.application = applicationObj.data;
        vm.resume = resume;

        function resume(UserPin) {
            $state.go('resume', {'UserPin': UserPin });
        }

        $log.debug(vm.application);
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('ConclusionController', ConclusionController);

    /** @ngInject */
    function ConclusionController($log, applicationObj, $window, $stateParams, $state, BookInfo) {
        $log.debug('Loaded: ConclusionController');

        var vm = this;

        var source = $window.localStorage.getItem('source');

        var EndText = applicationObj.data.Test.TestEndText
            .replace("#user_lname#", applicationObj.data.lastName)
            .replace("#user_fname#", applicationObj.data.firstName);

        vm.Endtext = EndText;
        vm.BookInfo = BookInfo;

        if(source == 'ac') {
          vm.Appcast = 'https://click.appcast.io/generic-9k/a17.png?ent=147&e=16122&t=1637162423218';
        } else {
          vm.Appcast = '';
        }

        vm.application = applicationObj.data;
        vm.exit = exit;

        function exit() {
            $log.debug(applicationObj);
            // var PassageNumber = applicationObj.data.TestTestTaker.CurrentSection;
            // var ItemPos = applicationObj.data.TestTestTaker.CurrentItemPos;
            $state.go('exit-review', {'UserPin': $stateParams.UserPin});
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('QuestionsController', QuestionsController);

    /** @ngInject */
    function QuestionsController($log, $state, $stateParams, Session, questionsObj, questionsApi, $filter) {
        $log.debug('Loaded: QuestionsController');
        $log.debug(questionsObj);

        var vm = this;
        var Passage;

        if($stateParams.PassageNumber) {
            Passage = $filter('filter')(questionsObj.data.Passages, function (d) {return d.NoPassage === $stateParams.PassageNumber;})[0];
            vm.firstPassage = 0;
        } else {
            Passage = questionsObj.data.Passages[0];
            vm.firstPassage = 1;
        }

        if(Passage.PassageDisplay == 'o') {
            if(questionsObj.data.Questions.TestItemNo == '0') {
                vm.firstPassage = 1;
            }
        }

        vm.submitForm = submitForm;
        vm.goBack = goBack;
        vm.onCheckBoxSelected = onCheckBoxSelected;

        vm.TransPhrases = questionsObj.data.TransPhrases;
        vm.questions = questionsObj.data.Questions;

        $log.debug(vm.TransPhrases);

        vm.passage = Passage;
        
        /*var html = '<table style="width:100%;"> \
        <tr> \
        <td align="center">1</td> \
            <td align="center">2</td> \
            <td align="center">3</td> \
            <td align="center">4</td> \
            <td align="center">5</td> \
            <td align="center">6</td> \
            <td align="center">7</td> \
            <td align="center">8</td> \
            </tr> \
            <tr> \
            <td align="center" class="ng-scope"><input type="radio" disabled></td> \
        <td align="center" class="ng-scope"><input type="radio" disabled></td> \
        <td align="center" class="ng-scope"><input type="radio" disabled></td> \
        <td align="center" class="ng-scope"><input type="radio" disabled></td> \
        <td align="center" class="ng-scope"><input type="radio" disabled></td> \
        <td align="center" class="ng-scope"><input type="radio" disabled></td> \
        <td align="center" class="ng-scope"><input type="radio" disabled></td> \
        <td align="center" class="ng-scope"><input type="radio" disabled></td> \
        </tr> \
        </table> \
        <table style="width:94%;" align="center"> \
            <tr> \
            <td style="padding-left:10px; font-size:11px;" align="left">Always<br>FALSE</td> \
            <td style="font-size:11px;" align="center">Sometimes<br>TRUE</td> \
            <td style="padding-right:10px; font-size:11px;" align="right">Always<br>TRUE</td> \
            </tr> \
            <tr> \
            <td colspan="3" align="left" style="font-weight:bold; padding-left:20px; font-size:0.9em"> \
            <br> \
            Example 1: <u>&nbsp;&nbsp;&nbsp;7&nbsp;&nbsp;&nbsp;</u> I like vanilla shakes &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(Where I really do like them!) \
    </td> \
        </tr> \
        <tr> \
        <td colspan="3" align="left" style="font-weight:bold; padding-left:20px; font-size:0.9em"> \
            Example 2: <u>&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;</u> I like lima bean ice cream &nbsp;&nbsp;&nbsp;&nbsp;(Where I absolutely hate it!) \
    </td> \
        </tr> \
        </table>';*/

        var html = '<img src="assets/images/scale.png" width="100%" heigth="auto" vspace="20">';

        var instructionsTextNew = vm.passage.InstructionsText.replace("#image0#", html);
        instructionsTextNew = instructionsTextNew.replace("#image1#", html);
        $log.debug(instructionsTextNew);

        vm.passage.InstructionsText = instructionsTextNew;

        function onCheckBoxSelected(checkedArray) {
            checkedArray.selected = false;
            for( var key in checkedArray.Choices) {
                if(checkedArray.Choices[key].UserAnswer === true) {
                    checkedArray.selected = true;
                }
            }
        }

        function goBack() {
            vm.loading = 1;

            if(Passage.PassageDisplay == 'o') {
                vm.questions['PassageType'] = 'Assessment';
            } else {
                vm.questions['PassageType'] = 'Application';
            }

            var dataObj = {'action':'goBack', 'PassageType': vm.questions['PassageType']};

            questionsApi.goBack($stateParams.UserPin, dataObj)
                .then(function (results) {
                    $log.debug('Pushing back');
                    $state.go('questions', {'UserPin': $stateParams.UserPin, 'PassageNumber': results.data.PassageNumber, 'ItemPos': results.data.ItemPos });
                })
                .catch(function (error) {
                    $log.debug('Error Submitting Form');
                    $log.debug(error);
                });
        }

        function submitForm(type) {
            vm.loading = 1;

            if(Passage.PassageDisplay == 'o') {
                vm.questions['PassageType'] = 'Assessment';
                $log.debug(vm.questions);
            } else {
                vm.questions['PassageType'] = 'Application';
            }

            if(type == 'finishLater') {
                questionsApi.saveTestAnswers($stateParams.UserPin, vm.questions)
                    .then(function (results) {
                        $log.debug(results);
                        $log.debug('Answers Accepted');
                        $log.debug('Exiting');
                        $state.go('exit', {'UserPin': $stateParams.UserPin });
                    })
                    .catch(function (error) {
                        $log.debug('Error Submitting Form');
                        $log.debug(error);
                    });
            } else {
                questionsApi.saveTestAnswers($stateParams.UserPin, vm.questions)
                    .then(function (results) {
                        $log.debug('Answers Accepted');
                        $log.debug('Continuing');
                        if(results.data.TestingComplete == 1) {
                            $state.go('conclusion', {'UserPin': $stateParams.UserPin });
                        } else {
                            $state.go('questions', {'UserPin': $stateParams.UserPin, 'PassageNumber': results.data.PassageNumber, 'ItemPos': results.data.ItemPos });
                        }
                    })
                    .catch(function (error) {
                        $log.debug('Error Submitting Form');
                        $log.debug(error);
                    });
            }

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('ApplicationController', ApplicationController);

    /** @ngInject */
    function ApplicationController($log, $state, $window, $stateParams, Session, testtakerApi, applicationObj, $http, $scope, Config, BookInfo) {
        $log.debug('Loaded: ApplicationController');

        var vm = this;

        var source = $window.localStorage.getItem('source');

        vm.submitForm = submitForm;
        vm.custAlert = custAlert;

        if(source == 'ac') {
          vm.Appcast = 'https://click.appcast.io/generic-te8/a31.png?ent=147&e=16122&t=1637162423218';
        } else {
          vm.Appcast = '';
        }

        vm.TransPhrases = applicationObj.data.TransPhrases;
        vm.Application = applicationObj.data.Test;
        vm.TestHeader = applicationObj.data.TestTestTaker.TestHeader;
        vm.RequireOverride = applicationObj.data.Test.RequireData;

        if(applicationObj.data.Test.RequireData == 1) {
            if(vm.Application.Name == 1) { vm.Application.Name = 2; }
            if(vm.Application.Workphone == 1) { vm.Application.Workphone = 2; }
            if(vm.Application.Address == 1) { vm.Application.Address = 2; }
            if(vm.Application.Email == 1) { vm.Application.Email = 2; }
            if(vm.Application.ConfirmEmail == 1) { vm.Application.ConfirmEmail = 2; }
        }

        vm.Resumeupload = BookInfo.BookDetails.Resumeupload;
        vm.ResumeuploadOptional = BookInfo.BookDetails.ResumeuploadOptional;
        vm.ResumeuploadRequired = BookInfo.BookDetails.ResumeuploadRequired;
        vm.Iscanada = BookInfo.BookDetails.Iscanada;

        $log.debug(vm.TransPhrases);

        vm.app = applicationObj.data;
        vm.SelectedCourseName = Session.get('SelectedCourseName');
        vm.SelectedPositionName = Session.get('SelectedPositionName');

        if(vm.SelectedCourseName === null) {
            vm.SelectedCourseName = applicationObj.data.Position.LocationName;
            vm.SelectedPositionName = applicationObj.data.Position.PositionName;
        }

        function submitForm(type) {
            vm.loading = 1;
            $log.debug(type);

            testtakerApi.updateTestTaker($stateParams.UserPin, vm.app)
                .then(function (results) {
                    $state.go('questions', {'UserPin': $stateParams.UserPin, 'Passage': results.passageNumber});
                })
                .catch(function (error) {
                    $log.debug('Error Submitting Form');
                    $log.debug(error);
                });


        }

        function custAlert(mesg) {
            console.log(mesg);
        }

        $scope.uploadFile = function(files) {
            var fd = new FormData();
            //Take the first selected file
            fd.append("file", files[0]);

            $http.post(Config.apiUrl + '/upload_file/'+$stateParams.UserPin, fd, {
                withCredentials: true,
                headers: {'Content-Type': undefined },
                transformRequest: angular.identity
            }).success(function(response) {
                console.log(response);
                vm.error = response.error;
                vm.success = response.success;
                vm.filename = response.filename;
                vm.message = response.message;
            }).error(function(error) {
                console.log(error);
                vm.error = error.error;
                vm.success = error.success;
                vm.message = error.message;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('PositionsController', PositionsController);

    /** @ngInject */
    function PositionsController($log, $state, positionsObj, $stateParams, Session, $filter) {
        $log.debug('Loaded: PositionsController');

        var vm = this;

        vm.positions = positionsObj.data.Positions;
        vm.gotoPositions = gotoPositions;
        vm.introText = positionsObj.data.Positions[0].IntroText;

        //vm.SelectedCourseName = Session.get('SelectedCourseName');

        //if(vm.SelectedCourseName === null) {
            vm.SelectedCourseName = positionsObj.data.CourseName;
        //}

        if($stateParams.NoPosition) {
            //vm.SelectedPositionName = Session.get('SelectedPositionName');
        }

        function gotoPositions(NoPosition) {
            vm.loading = 1;

            var Position  = $filter('filter')(positionsObj.data.Positions, function (d) {return d.NoPosition === NoPosition;})[0];

            Session.set('SelectedPositionName', Position.Name);
            Session.set('SelectedInitialExp', Position.InitialExp);

            $state.go('positions', {'NoCourse':$stateParams.NoCourse, 'NoPosition':NoPosition});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('LocationsController', LocationsController);

    /** @ngInject */
    function LocationsController($log, $state, BookInfo, $filter, Session) {
        $log.debug('Loaded: LocationsController');

        var vm = this;


        $log.debug(BookInfo);

        vm.courses = BookInfo.Courses;
        vm.gotoPositions = gotoPositions;
        vm.introText = BookInfo.BookDetails.IntroText;

        function gotoPositions(NoCourse) {
            vm.loading = 1;
            var course = $filter('filter')(BookInfo.Courses, function (d) {return d.NoCourse === NoCourse;})[0];
            Session.set('SelectedCourseName', course.CourseName);

            $state.go('postingPage', {'NoCourse':NoCourse});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('LandingController', LandingController);

    /** @ngInject */
    function LandingController($log, $state, $stateParams, BookInfo, $filter, $window) {
        $log.debug('Loaded: LandingController');

        var vm = this;
        var slug = $stateParams.slug;

        slug = slug.toUpperCase();

        vm.landingLinks = BookInfo.LandingCodes[slug];

        vm.gotoLink = gotoLink;

        function gotoLink(url) {
            $window.location.href = url;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .controller('BreakController', BreakController);

    /** @ngInject */
    function BreakController($log, $state, applicationObj, $stateParams, BookInfo, $filter, testtakerApi) {
        $log.debug('Loaded: BreakController');

        var vm = this;

        vm.pin = $stateParams.UserPin;
        vm.bookId = BookInfo.BookDetails.BookId;

        vm.resume = resume;
        vm.submitForm = submitForm;

        if($state.current.name === 'resume') {
            resume();
        }

        if($state.current.name === 'restart') {
            restart();
        }

        function resume() {
            $log.debug(applicationObj);
            var PassageNumber = applicationObj.data.TestTestTaker.CurrentSection;
            var ItemPos = applicationObj.data.TestTestTaker.CurrentItemPos;
            $state.go('questions', {'UserPin': $stateParams.UserPin, 'PassageNumber': PassageNumber, 'ItemPos': ItemPos });
        }

        function restart() {
            $log.debug(applicationObj);
            var PassageNumber = applicationObj.data.TestTestTaker.CurrentSection;
            var ItemPos = applicationObj.data.TestTestTaker.CurrentItemPos;
            $state.go('questions', {'UserPin': $stateParams.UserPin, 'PassageNumber': PassageNumber, 'ItemPos': ItemPos });
        }

        function submitForm() {
            if($filter('uppercase')(vm.username) == 'GUEST') {
                testtakerApi.getTestTakerByPin(vm.pin)
                    .then(function (results) {
                        $log.debug(results);
                        $state.go('resume', {'UserPin': vm.pin });
                    })
                    .catch(function (error) {
                        $log.debug(error);
                        vm.error = 'Invalid Pin, please try again.';
                    });
            } else {
                vm.error = 'Invalid Username, please try again.';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, $window, $state, $location) {
        $log.debug('Traitset Application Ran');

        var queryParam = $location.search();
        var r = queryParam.r;

        if(r) { $window.localStorage.setItem('source', r); }

        $rootScope.$on("$stateChangeStart", function(){
            $window.scrollTo(0, 0);
        });

        $rootScope.$on('$stateChangeError', function(event) {
            $state.go('404');
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('locationFinder', {
                url: '/locationFinder',
                templateUrl: 'app/locationFinder/locationFinder.html',
                controller: 'LocationFinderController',
                controllerAs: 'vm'
            })
            .state('locations', {
                url: '/locations',
                templateUrl: 'app/1-locations/locations.html',
                controller: 'LocationsController',
                controllerAs: 'vm'
            })
            .state('404', {
                url: '/404',
                templateUrl: 'app/404.html'
            })
            .state('exit', {
                url: '/exit/:UserPin',
                templateUrl: 'app/0-break/exit.html',
                controller: 'BreakController',
                controllerAs: 'vm',
                resolve: {
                    applicationObj: function ($stateParams, $log, testtakerApi) {
                        return testtakerApi.getTestTakerByPin($stateParams.UserPin);
                    }
                }
            })
            .state('a', {
                url: '/a/:slug',
                templateUrl: 'app/0-landing/landing.html',
                controller: 'LandingController',
                controllerAs: 'vm'
            })
            .state('entry', {
                url: '/entry',
                templateUrl: 'app/0-break/entry.html',
                controller: 'BreakController',
                controllerAs: 'vm',
                resolve: {
                    applicationObj: function () {
                        return null;
                    }
                }
            })
            .state('resume', {
                url: '/resume/:UserPin',
                templateUrl: 'app/0-break/resume.html',
                controller: 'BreakController',
                controllerAs: 'vm',
                resolve: {
                    applicationObj: function ($stateParams, $log, testtakerApi) {
                        return testtakerApi.getTestTakerByPin($stateParams.UserPin);
                    }
                }
            })
            .state('restart', {
                url: '/restart/:UserPin',
                templateUrl: 'app/0-break/restart.html',
                controller: 'BreakController',
                controllerAs: 'vm',
                resolve: {
                    applicationObj: function ($stateParams, $log, testtakerApi) {
                        return testtakerApi.getTestTakerByPin($stateParams.UserPin);
                    }
                }
            })
            .state('positions', {
                url: '/positions/:NoCourse/:NoPosition',
                templateUrl: 'app/2-positions/positions.html',
                controller: 'PositionsController',
                controllerAs: 'vm',
                resolve: {
                    positionsObj: function ($stateParams, $log, positionsApi, $q, $state, testtakerApi, BookInfo, Session, $window) {
                        var returnValue = null
                        if($stateParams.NoPosition) {
                            returnValue = positionsApi.getPositionByPositionId($stateParams.NoCourse, $stateParams.NoPosition);

                            returnValue.then(function(response) {
                                if(response.data.create_testtaker === 1) {
                                    var testTakerValues = {
                                        'NoAdmin':BookInfo.BookDetails.NoAdmin,
                                        'NoCompany':BookInfo.BookDetails.NoCompany,
                                        'NoBook':BookInfo.BookDetails.NoBook,

                                        'NoCourse':$stateParams.NoCourse,
                                        'CurrentPosition':$stateParams.NoPosition,

                                        'NoProfile':Session.get('SelectedInitialExp'),
                                        'Source': $window.localStorage.getItem('source'),
                                        'BrowserString':'Nathan Testing'
                                    };

                                    testtakerApi.createTestTaker(testTakerValues).then(function (results) {
                                        return $q.reject().catch(function(){$state.go('application', {'UserPin':results.data.UserPin}); return $q.reject();})
                                    });
                                }
                            });
                        } else {
                            returnValue = positionsApi.getPositionByCourseId($stateParams.NoCourse);
                        }

                        return returnValue;
                    }
                }
            })
            .state('application', {
                url: '/application/:UserPin',
                templateUrl: 'app/3-application/application.html',
                controller: 'ApplicationController',
                controllerAs: 'vm',
                resolve: {
                    applicationObj: function ($stateParams, $log, testtakerApi) {
                        return testtakerApi.getTestTakerByPin($stateParams.UserPin);
                    }
                }
            })
            .state('questions', {
                url: '/questions/:UserPin/:PassageNumber/:ItemPos',
                templateUrl: 'app/4-questions/questions.html',
                controller: 'QuestionsController',
                controllerAs: 'vm',
                resolve: {
                    questionsObj: function ($stateParams, $log, questionsApi) {
                        return questionsApi.getQuestionsByPin($stateParams.UserPin);
                    }
                }
            })
            .state('conclusion', {
                url: '/conclusion/:UserPin',
                templateUrl: 'app/5-conclusion/conclusion.html',
                controller: 'ConclusionController',
                controllerAs: 'vm',
                resolve: {
                    applicationObj: function ($stateParams, $log, testtakerApi) {
                        return testtakerApi.getTestTakerByPin($stateParams.UserPin);
                    }
                }
            })
            .state('exit-review', {
                url: '/exit-review/:UserPin',
                templateUrl: 'app/6-exit-review/exit-review.html',
                controller: 'ExitReviewController',
                controllerAs: 'vm',
                resolve: {
                    applicationObj: function ($stateParams, $log, testtakerApi) {
                        return testtakerApi.getTestTakerByPin($stateParams.UserPin);
                    }
                }
            })
            .state('postingDetail', {
                url: '/postingDetail/:NoPosition?r',
                templateUrl: 'app/postingDetail/postingDetail.html',
                controller: 'PostingDetailController',
                controllerAs: 'vm',
                resolve: {
                    postingDetailObj: function ($stateParams, $log, postingDetailApi) {
                        return postingDetailApi.getPostedPositionByNo($stateParams.NoPosition);
                    }
                }
            })
            .state('postingPage', {
                url: '/postingPage/:NoCourse/:NoBook?NoPosition&r',
                templateUrl: 'app/postingPage/postingPage.html',
                controller: 'PostingPageController',
                controllerAs: 'vm',
                resolve: {
                    postingPageObj: function ($stateParams, $log, postingPageApi) {
                        return postingPageApi.getPostingsByLocationBook($stateParams.NoCourse, $stateParams.NoBook, $stateParams.NoPosition);
                    }
                }
            })
            .state('samplecolors', {
                // Temporary
                url: '/samplecolors',
                templateUrl: 'app/sample-colors/sample-colors.html',
                controller: 'SampleColorsController',
                controllerAs: 'vm'
            });

        $urlRouterProvider.otherwise('locations');
    }
})();
(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .constant('Config', {
            // 'apiUrl': 'http://new.traitset.com/api' /* dev */
            'apiUrl': '/api'
        });

})();

(function () {
    'use strict';

    angular
        .module('traitsetApplication')
        .config(config);

    /** @ngInject */
    function config($logProvider, $httpProvider, $locationProvider) {
        // Enable log
        $logProvider.debugEnabled(true);
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        $locationProvider.html5Mode(true).hashPrefix('!');
    }

})();

/*'use strict';

angular.module('traitsetApplication')
    .constant('BookInfo', {
        "BookDetails": {
            "NoBook": "584",
            "BookId": "abc321",
            "BookName": "ABC Company - 321Forms",
            "BookDescription": null,
            "BundlePrice": "0",
            "Launched": "0",
            "NoAdmin": "830",
            "NoCompany": "789",
            "NoStyle": "220",
            "NoUserGroup": "",
            "BookType": "1",
            "CompanyName": "ABC Company - 321Forms",
            "Ismaster": "1",
            "MasterBook": "",
            "NoReseller": "",
            "ResultsLogin": "1",
            "ReturnLink": " ",
            "LinkText": " ",
            "TraitsetReport": "",
            "ChangePassword": "0",
            "DisplayEntry": "",
            "NotifyEmail": "#user_fname# #user_lname# has completed the #experience#<br>on #current_time# for location #groupname#.<br><br>Click on link to view their report #cur1#",
            "Isobselete": "0",
            "FaxReady": "0",
            "LocationFormtext": " ",
            "LocationResultstext": " ",
            "OnboardingUsername": "",
            "OnboardingPassword": "",
            "OnboardingWebservice": "",
            "OnboardingExternalid": "",
            "OnboardingEncryptionkey": "",
            "Emeraldid": "",
            "Istemplate": "0",
            "Hideforms": "1",
            "Hidelocmanager": "0",
            "Zipfinderurl": "",
            "Allowcandidatedocuments": "1",
            "Indeed": "1",
            "Indeeddemoonly": "1"
        },
        "Style": {
            "AdminStyle": {
                "NoStyle": "219",
                "ExpBgcolor": "15658734",
                "ExpTitlecolor": "3355494",
                "ExpTextcolor": "16777215",
                "InstBgcolor": "14737639",
                "InstTitlecolor": "15790327",
                "InstTextcolor": "85",
                "InstSubtitlecolor": "16448255",
                "InstTextbgcolor": "16777215",
                "InstSubtextcolor": "0",
                "ItemBgcolor": "15790320",
                "ItemTextcolor": "0",
                "ItemChLgcolor": "15133948",
                "ItemChDkcolor": "13097983",
                "ItemRsLgcolor": "15133948",
                "ItemRsDkcolor": "13097983",
                "Isdefault": "1",
                "NoAdmin": "830",
                "StyleName": "Winteri",
                "BgImage": "",
                "ExpImage": "",
                "InstImage": ""
            },
            "BaseStyle": {
                "NoStyle": "220",
                "ExpBgcolor": "15658734",
                "ExpTitlecolor": "3355494",
                "ExpTextcolor": "16777215",
                "InstBgcolor": "14737639",
                "InstTitlecolor": "15790327",
                "InstTextcolor": "85",
                "InstSubtitlecolor": "16448255",
                "InstTextbgcolor": "16777215",
                "InstSubtextcolor": "0",
                "ItemBgcolor": "15790320",
                "ItemTextcolor": "0",
                "ItemChLgcolor": "15133948",
                "ItemChDkcolor": "13097983",
                "ItemRsLgcolor": "15133948",
                "ItemRsDkcolor": "13097983",
                "Isdefault": "0",
                "NoAdmin": "830",
                "StyleName": "Central Bundle Style",
                "BgImage": "",
                "ExpImage": "1315",
                "InstImage": ""
            }
        },
        "Courses": [
            {
                "NoCourse": "6060",
                "CourseName": "ABC Store # 321",
                "EntryExtra": ""
            },
            {
                "NoCourse": "6061",
                "CourseName": "ABC Store # 456",
                "EntryExtra": ""
            },
            {
                "NoCourse": "6992",
                "CourseName": "Anthony House (NTC2)",
                "EntryExtra": ""
            },
            {
                "NoCourse": "7321",
                "CourseName": "Beach Hotel",
                "EntryExtra": ""
            },
            {
                "NoCourse": "8472",
                "CourseName": "Fast Foods Store #789 - Saline MI",
                "EntryExtra": ""
            }
        ]
    }); */
angular.module("traitsetApplication").run(["$templateCache", function($templateCache) {$templateCache.put("app/404.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><br><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; background-color:#369; border:1px solid #369; color:#fff\">Error Loading Application</div><br><div style=\"font-size:1.2em; text-align:center; font-weight:bold; margin-bottom:10px\">Error Loading the application. Please restart the process.</div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/0-break/entry.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><br><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; background-color:#369; border:1px solid #369; color:#fff\">Resume Application Process</div><br><div>You may resume your process by entering your username and pin below.<br><br><form ng-submit=\"vm.submitForm(\'continue\')\"><div class=form-group><label for=username style=font-weight:bold>Username</label><input type=text class=form-control id=username placeholder=Username ng-model=vm.username></div><div class=form-group><label for=pin style=font-weight:bold>Pin</label><input type=text class=form-control id=pin placeholder=Pin ng-model=vm.pin></div><br><div style=\"font-weight:bold; color:#900\">{{vm.error}}</div><br><button type=submit class=\"btn btn-primary btn-block\">Continue Now</button></form></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/0-break/exit.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><br><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; background-color:#369; border:1px solid #369; color:#fff\">Application</div><br><div style=\"font-size:1.2em; text-align:center; font-weight:bold; margin-bottom:10px\">Attention: You have not completed the process yet.</div><div>You may exit now and continue where you left off later. When you wish to resume go to: <a href=https://{{vm.bookId}}.traitset.com/entry>https://{{vm.bookId}}.traitset.com/entry</a> and enter your User Name and PIN.<br><br>Username: guest<br>Pin: {{vm.pin}}<br><br>Or, you can use this hotlink which will return you to the test where you left off. <a href=https://{{vm.bookId}}.traitset.com/resume/{{vm.pin}}>https://{{vm.bookId}}.traitset.com/resume/{{vm.pin}}</a><br><br>Or, you can resume now using the button below:<br><br></div><button type=button ng-click=vm.resume() class=\"btn btn-primary btn-block\">Continue Now</button></div><nav-footer></nav-footer></div>");
$templateCache.put("app/0-break/resume.html","");
$templateCache.put("app/0-landing/landing.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><div style=text-align:center><div ng-if=!vm.courses.error ng-repeat=\"link in vm.landingLinks\" style=margin-top:20px><button ng-click=vm.gotoLink(link.link_href) type=button class=\"btn btn-primary btn-block\">{{link.link_title}}</button></div></div><div></div></div></div><nav-footer></nav-footer>");
$templateCache.put("app/1-locations/locations.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><div style=text-align:center><span ng-bind-html=vm.introText></span><br><br><div ng-if=!vm.courses.error ng-repeat=\"course in vm.courses\" style=margin-top:20px><button ng-click=vm.gotoPositions(course.NoCourse) type=button class=\"btn btn-primary btn-block\">{{course.CourseName}}</button></div></div><div></div></div></div><nav-footer></nav-footer>");
$templateCache.put("app/2-positions/positions.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><div style=text-align:center><br><div style=\"font-size:1.2em; margin-top:-30px; padding:0; text-align:center; font-weight:bold\">{{vm.SelectedCourseName}}<br>{{vm.SelectedPositionName}}</div><div style=\"font-size:0.9em; font-weight:normal; margin-top:12px\"><span ng-bind-html=vm.introText></span><br><br><button ng-repeat=\"position in vm.positions\" ng-click=vm.gotoPositions(position.NoPosition) type=button class=\"btn btn-primary btn-block\" ng-show=position.Name>{{position.Name}}</button><br><button onclick=history.back() type=button class=\"btn btn-default btn-block\">Go Back</button></div></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/3-application/application.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading style=margin:5px><div style=text-align:center><br><div style=\"font-size:1.2em; margin-top:-30px; padding:0; text-align:center; font-weight:bold\">{{vm.SelectedCourseName}}<br>{{vm.SelectedPositionName}}</div><div style=\"font-size:0.9em; font-weight:normal; margin-top:12px; text-align:left; background-color:#fff; margin-top:5px\"><!--<p style=\"padding:6px; background-color:#eee;\">Please complete the following information and click on the \"Save & Continue\" button at the bottom.</p>--><!--<p style=\"padding:6px; background-color:#eee;\">You may use the TAB key to move between the boxes below.</p>--><div class=row><p style=padding:6px ng-bind-html=vm.TestHeader></p><p style=\"padding:6px; background-color:#fff; border:2px lightgrey dotted\"><b>Note:</b> Required fields have <span style=\"color:lightcoral; font-weight:bold\">red</span> border. Complete and valid fields have <span style=\"color:lightgreen; font-weight:bold;-webkit-background-origin: ;background-origin:\">green</span> border.<br>You may put N/A in a field if it does not apply.</p></div><form name=application ng-submit=\"vm.submitForm(\'continue\')\"><!--                    <div class=\"row\" ng-if=\"vm.Application.Address > 0\">\n                        <div class=\"form-group col-sm-11 nopadding\">\n                            <label for=\"country\">Country</label>\n                            <select ng-model=\"vm.app.country\" type=\"text\" class=\"form-control\" id=\"country\" ng-required=\"vm.Application.Address == 2\">\n                                <option value=\"\"></option>\n                                <option value=\"US\">United States</option>\n                                <option value=\"CA\">Canada</option>\n                            </select>\n                        </div>\n                    </div>--> <img src={{vm.Appcast}} style=\"display: none\" width=1px height=1px><div class=row ng-if=\"vm.Application.Name > 0\"><div class=\"form-group col-sm-8 nopadding\"><label for=firstName>{{vm.TransPhrases.Fname}}</label><input ng-model=vm.app.firstName type=text class=form-control id=firstName placeholder={{vm.TransPhrases.Fname}} ng-required=\"vm.Application.Name == 2\"></div><div class=\"form-group col-sm-4 nopadding\"><label for=mi>{{vm.TransPhrases.Mi}}</label><input ng-model=vm.app.middleInitial type=text class=form-control id=mi placeholder={{vm.TransPhrases.Mi}} imit-to=1 maxlength=1 oninput=\"if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)\"></div></div><div class=row ng-if=\"vm.Application.Name > 0\"><div class=\"form-group col-sm-12 nopadding\"><label for=lastName>{{vm.TransPhrases.Lname}}</label><input ng-model=vm.app.lastName type=text class=form-control id=lastName placeholder={{vm.TransPhrases.Lname}} ng-required=\"vm.Application.Name == 2\"></div></div><div class=row ng-if=\"vm.Application.Ssn > 0\"><div class=\"form-group col-xs-12 col-sm-6 nopadding\"><label>{{vm.TransPhrases.Ssn}}</label><br><input ng-model=vm.app.ssn type=text class=form-control></div><!--\n                        <div class=\"col-md-6\" style=\"padding:0;\">\n                            <label>{{vm.TransPhrases.Ssn}}</label>\n                            <br>\n                            <div class=\"form-group col-xs-4 nopadding\">\n                                <input ng-model=\"vm.app.ssn1\" type=\"number\" class=\"form-control\" limit-to=\"3\" maxlength=\"3\" placeholder=\"XXX\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\">\n                            </div>\n                            <div class=\"form-group col-xs-4 nopadding\">\n                                <input ng-model=\"vm.app.ssn2\" type=\"number\" class=\"form-control\" limit-to=\"2\" maxlength=\"2\" placeholder=\"XX\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\">\n                            </div>\n                            <div class=\"form-group col-xs-4 nopadding\">\n                                <input ng-model=\"vm.app.ssn3\" type=\"number\" class=\"form-control\" limit-to=\"4\" maxlength=\"4\" placeholder=\"XXXX\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\">\n                            </div>\n                        </div>\n--></div><div class=row ng-if=\"vm.Application.Workphone > 0\"><div class=\"form-group col-xs-12 col-sm-6 nopadding\"><label>{{vm.TransPhrases.WorkPhone}}</label><br><input ng-model=vm.app.workPhone type=text class=form-control ui-mask=\"(999) 999-9999\" ng-required=\"vm.Application.Workphone == 2\"></div></div><div class=row ng-if=\"vm.Application.Homephone > 0\"><div class=\"form-group col-xs-12 col-sm-6 nopadding\"><label>{{vm.TransPhrases.Home}}</label><br><input ng-model=vm.app.homePhone type=text class=form-control ui-mask=\"(999) 999-9999\" ng-required=\"vm.Application.Homephone == 2\"></div></div><div class=row ng-if=\"vm.Application.Email > 0\"><div class=\"form-group col-sm-12 nopadding\"><label>{{vm.TransPhrases.Email}}</label><input ng-model=vm.app.emailAddress type=email class=form-control id=emailAddress placeholder={{vm.TransPhrases.Email}} ng-required=\"vm.Application.ConfirmEmail == 2\"></div></div><div class=row ng-if=\"vm.app.emailAddressConfirm != vm.app.emailAddress && vm.Application.ConfirmEmail > 0\"><div style=\"color:#fff; background-color: #f08080; width:99%; text-align:center; border-radius:4px; margin-left:4px; padding:3px\">Email Address and Confirm Email Must Match</div></div><div class=row ng-if=\"vm.Application.ConfirmEmail > 0\"><div class=\"form-group col-sm-12 nopadding\"><label for=conEmailAddress>Confirm Email</label><input ng-model=vm.app.emailAddressConfirm type=email class=form-control id=conEmailAddress placeholder=\"Confirm Email\" ng-required=\"vm.Application.ConfirmEmail == 2\"></div></div><div class=row ng-if=\"vm.Application.Address > 0\"><div class=\"form-group col-sm-12 nopadding\"><label for=streetAddress>{{vm.TransPhrases.Street}}</label><input ng-model=vm.app.streetAddress type=text class=form-control id=streetAddress placeholder={{vm.TransPhrases.Street}} ng-required=\"vm.Application.Address == 2\"></div></div><div class=row ng-if=\"vm.Application.Address > 0\"><div class=\"form-group col-sm-12 nopadding\"><label for=city>{{vm.TransPhrases.City}}</label><input ng-model=vm.app.city type=text class=form-control id=city placeholder={{vm.TransPhrases.City}} ng-required=\"vm.Application.Address == 2\"></div></div><div class=row ng-if=\"vm.Application.Address > 0\"><div class=\"form-group col-sm-8 nopadding\" ng-if=\"vm.Iscanada == \'1\'\"><label for=state>Province</label><select ng-model=vm.app.state type=text class=form-control id=state ng-required=\"vm.Application.Address == 2\"><!--                                <option value=\"\"></option>--><!--                                <option value=\"AB\">Alberta</option>--><!--                                <option value=\"BC\">British Columbia</option>--><!--                                <option value=\"MB\">Manitoba</option>--><!--                                <option value=\"NB\">New Brunswick</option>--><!--                                <option value=\"NL\">Newfoundland and Labrador</option>--><!--                                <option value=\"NS\">Nova Scotia</option>--><!--                                <option value=\"ON\">Ontario</option>--><!--                                <option value=\"PE\">Prince Edward Island</option>--><!--                                <option value=\"QC\">Quebec</option>--><!--                                <option value=\"SK\">Saskatchewan</option>--><option value=Alberta>Alberta</option><option value=\"British Columbia\">British Columbia</option><option value=Manitoba>Manitoba</option><option value=\"New Brunswick\">New Brunswick</option><option value=\"Newfoundland and Labrador\">Newfoundland and Labrador</option><option value=\"Northwest Territories\">Northwest Territories</option><option value=\"Nova Scotia\">Nova Scotia</option><option value=Nunavut>Nunavut</option><option value=Ontario>Ontario</option><option value=\"Prince Edward Island\">Prince Edward Island</option><option value=Quebec>Quebec</option><option value=Saskatchewan>Saskatchewan</option><option value=Yukon>Yukon</option></select></div><div class=\"form-group col-sm-8 nopadding\" ng-if=\"vm.Iscanada == \'0\' || vm.Iscanada == \'\'\"><label for=firstName>{{vm.TransPhrases.State}}</label><select ng-model=vm.app.state type=text class=form-control id=state ng-required=\"vm.Application.Address == 2\"><option value=\"\"></option><option value=AL>Alabama</option><option value=AK>Alaska</option><option value=AZ>Arizona</option><option value=AR>Arkansas</option><option value=CA>California</option><option value=CO>Colorado</option><option value=CT>Connecticut</option><option value=DE>Delaware</option><option value=DC>District Of Columbia</option><option value=FL>Florida</option><option value=GA>Georgia</option><option value=HI>Hawaii</option><option value=ID>Idaho</option><option value=IL>Illinois</option><option value=IN>Indiana</option><option value=IA>Iowa</option><option value=KS>Kansas</option><option value=KY>Kentucky</option><option value=LA>Louisiana</option><option value=ME>Maine</option><option value=MD>Maryland</option><option value=MA>Massachusetts</option><option value=MI>Michigan</option><option value=MN>Minnesota</option><option value=MS>Mississippi</option><option value=MO>Missouri</option><option value=MT>Montana</option><option value=NE>Nebraska</option><option value=NV>Nevada</option><option value=NH>New Hampshire</option><option value=NJ>New Jersey</option><option value=NM>New Mexico</option><option value=NY>New York</option><option value=NC>North Carolina</option><option value=ND>North Dakota</option><option value=OH>Ohio</option><option value=OK>Oklahoma</option><option value=OR>Oregon</option><option value=PA>Pennsylvania</option><option value=RI>Rhode Island</option><option value=SC>South Carolina</option><option value=SD>South Dakota</option><option value=TN>Tennessee</option><option value=TX>Texas</option><option value=UT>Utah</option><option value=VT>Vermont</option><option value=VA>Virginia</option><option value=WA>Washington</option><option value=WV>West Virginia</option><option value=WI>Wisconsin</option><option value=WY>Wyoming</option></select></div><div class=\"form-group col-sm-4 nopadding\"><label for=mi>{{vm.TransPhrases.Zip}}</label><input ng-model=vm.app.zip type=text class=form-control id=zip ng-required=\"vm.Application.Address == 2\"></div></div><div class=row ng-if=\"vm.Application.Data1.length > 1\"><div class=\"form-group col-sm-12 nopadding\"><label for=data1>{{vm.Application.Data1}}</label><input ng-model=vm.app.data1 type=text class=form-control id=data1 placeholder=\"\" ng-required=\"vm.Application.Isdata1 == 2\"></div></div><div class=row ng-if=\"vm.Application.Data2.length > 1\"><div class=\"form-group col-sm-12 nopadding\"><label for=data2>{{vm.Application.Data2}}</label><input ng-model=vm.app.data2 type=text class=form-control id=data2 placeholder=\"\" ng-required=\"vm.Application.Isdata2 == 2\"></div></div><div class=row ng-if=\"vm.Application.Data3.length > 1\"><div class=\"form-group col-sm-12 nopadding\"><label for=data3>{{vm.Application.Data3}}</label><input ng-model=vm.app.data3 type=text class=form-control id=data3 placeholder=\"\" ng-required=\"vm.Application.Isdata3 == 2\"></div></div><div class=row ng-if=\"vm.Application.Data4.length > 1\"><div class=\"form-group col-sm-12 nopadding\"><label for=data4>{{vm.Application.Data4}}</label><input ng-model=vm.app.data4 type=text class=form-control id=data4 placeholder=\"\" ng-required=\"vm.Application.Isdata4 == 2\"></div></div><div class=row ng-if=vm.Resumeupload><div class=\"form-group col-sm-12 nopadding\" style=\"width:85% !important; border:2px solid #ddd !important; margin:10px !important; padding:8px !important\"><div ng-if=!vm.success><span ng-if=vm.error style=\"font-size:1.0em; font-weight:bold; color:#900\">Error Uploading File: {{vm.message}}<br></span><label for=uploadResume style=\"font-weight:bold; font-size:1.1em\">Upload Resum&eacute;<span style=font-size:0.7em ng-if=!vm.ResumeuploadOptional>&nbsp;(OPTIONAL)</span><span style=font-size:0.7em ng-if=\"vm.ResumeuploadRequired == 1\">&nbsp;(REQUIRED)</span>:</label><br><input ng-required=\"vm.ResumeuploadRequired == 1\" id=uploadResume type=file name=file onchange=angular.element(this).scope().uploadFile(this.files) accept=\"application/rtf, text/plain, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.openxmlformats-officedocument.wordprocessingml.document\"><br><span style=font-size:0.7em>Allowed Files: MS Word (doc, docx), Adobe PDF, Plain Text, Rich Text Format</span></div><div ng-if=vm.success><span style=\"font-size:1.1em; font-weight:bold; color:#090\">{{vm.message}}<br></span><span style=\"font-size:1.0em; color:#000\">{{vm.filename}}<br></span></div></div></div><div class=row ng-show=\"application.$valid && ((vm.app.emailAddressConfirm == vm.app.emailAddress && vm.Application.ConfirmEmail > 0) || vm.Application.ConfirmEmail == 0)\" style=\"margin-top:6px; padding:5px\"><button type=submit class=\"btn btn-primary btn-block\">{{vm.TransPhrases.Cont}}</button></div><div class=row ng-show=application.$invalid style=\"margin-top:6px; padding:5px\"><button type=submit class=\"btn btn-block\" style=\"background-color:lightcoral; color:#fff\" disabled>To continue, complete all required fields.</button></div><div class=row ng-show=\"vm.Application.ConfirmEmail > 0 && vm.app.emailAddressConfirm !== vm.app.emailAddress\" style=\"margin-top:6px; padding:5px\"><button type=submit class=\"btn btn-block\" style=\"background-color:lightcoral; color:#fff\" disabled>To continue, email fields must match.</button></div><!--<button ng-click=\"vm.submitForm(\'finishLater\')\" type=\"button\" class=\"btn btn-secondary btn-block\">Save and Finish Later</button>--></form></div></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/4-questions/instructions.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container><div style=text-align:center><br><div style=\"font-size:1.2em; margin-top:-30px; padding:0; text-align:center; font-weight:bold\">General Instructions</div><p style=\"text-align:left; margin-top:20px\">In answering questions, choose the number which most closely matches your feelings using the scale shown below.</p><form><hr><div style=\"text-align:left; border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><h5>Example 1:</h5><div>I like vanilla shakes.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled selected checked></td><td align=center><input type=radio name=optradio1 disabled></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><h5 style=\"padding:20px; color:#090\">Means: I really do like it!</h5></div><div style=\"text-align:left; border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><h5>Example 2:</h5><div>I like lima bean ice cream.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio2 disabled selected checked></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><h5 style=\"padding:20px; color:#900\">Means: I hate it!</h5></div></form>Please click on the \"Save & Continue\" button at the bottom of each screen to save your answers.<br><br><i>Thank you!</i><p></p></div><button ui-sref=assessment type=button class=\"btn btn-primary btn-block\">Save and Continue</button> <button ui-sref=instructions type=button class=\"btn btn-secondary btn-block\">Save and Finish Later</button></div><nav-footer></nav-footer></div>");
$templateCache.put("app/4-questions/questions.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><br><div style=\"font-size:1.2em; text-align:center; font-weight:bold; margin-bottom:10px\">{{vm.passage.PassageName}}</div><div style=\"font-size:1.0em; text-align:justify; margin-bottom:10px\"><span ng-bind-html=vm.passage.PassageText></span></div><div style=\"font-size:1.0em; text-align:justify; margin-bottom:20px\"><span ng-bind-html=vm.passage.InstructionsText></span></div><form name=questions ng-submit=\"vm.submitForm(\'continue\')\"><div style=text-align:left><div ng-repeat=\"(key,value) in vm.questions\" class=form-group ng-if=\"vm.passage.PassageDisplay != \'o\'\"><div ng-hide=\"value.HasCondition && !value.ConditionMet\"><hr><span ng-bind-html=value.QuestionText></span><div ng-if=\"value.Type == \'S\'\" class=radio><div ng-if=\"!value.UserAnswer && value.SkipReview != 1\" style=\"color:#fff; background-color: #f08080; border-radius:4px; width:100%; text-align:center\">Required</div><!--<div ng-if=\"value.UserAnswer && value.SkipReview != 1\" style=\"color:#fff; background-color: #90ee90; width:100%; text-align:center;\">Valid</div>--><label ng-repeat=\"(k, v) in value.Choices\" style=\"display:block; margin-left:20px; margin-top:5px\"><input type=radio ng-model=value.UserAnswer ng-value=v.ChoiceAnswer ng-required=\"!value.UserAnswer && value.SkipReview != 1\"> <span ng-bind-html=v.ChoiceText></span><div ng-if=v.InlineQuestion><input type=text ng-model=v.InlineQuestionAnswer class=form-control ng-required=\"value.UserAnswer==v.ChoiceAnswer && value.SkipReview != 1\"></div></label></div><div ng-if=\"value.Type == \'N\'\" class=radio><div ng-if=\"!value.selected && value.SkipReview != 1\" style=\"color:#fff; background-color: #f08080; border-radius:4px; width:100%; text-align:center\">Required</div><!--<div ng-if=\"value.selected && value.SkipReview != 1\" style=\"color:#fff; background-color: #90ee90; width:100%; text-align:center;\">Valid</div>--><label ng-repeat=\"(k, v) in value.Choices\" style=\"display:block; margin-left:20px; margin-top:5px\"><input type=checkbox ng-model=v.UserAnswer ng-value=v.ChoiceAnswer ng-checked=\"v.UserAnswer==\'A\'\" ng-change=vm.onCheckBoxSelected(value) ng-required=\"!value.selected && value.SkipReview != 1\"> <span ng-bind-html=v.ChoiceText></span><div ng-if=v.InlineQuestion><input type=text ng-model=v.InlineQuestionAnswer class=form-control ng-required=\"v.UserAnswer == true && value.SkipReview != 1\"></div></label></div><div ng-if=\"value.Type == \'T\'\"><div ng-if=\"value.Response == \'S\'\"><input type=text ng-model=value.UserAnswer class=form-control ng-required=\"!value.UserAnswer && value.SkipReview != 1\"></div><div ng-if=\"value.Response == \'L\'\"><textarea ng-model=value.UserAnswer rows=3 class=form-control ng-required=\"!value.UserAnswer && value.SkipReview != 1\"></textarea></div></div></div></div><div ng-repeat=\"(key,value) in vm.questions.AssessmentQuestions\" class=form-group ng-if=\"vm.passage.PassageDisplay == \'o\'\"><div style=\"padding-top:5px; font-size:0.9em\"><hr><div style=padding-bottom:14px>{{value.Title}}</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center ng-repeat=\"(k, v) in value.Choices\"><input type=radio ng-model=value.UserAnswer ng-value=v.ChoiceAnswer class=assessmentRadio ng-required=!value.UserAnswer></td></tr></table><table style=width:94% align=center><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table></div></div></div><hr><br><button ng-show=questions.$valid type=submit class=\"btn btn-primary btn-block\">{{vm.TransPhrases.Cont}}</button> <button ng-show=questions.$invalid type=submit class=\"btn btn-block\" style=\"background-color:lightcoral; color:#fff\" disabled>To continue, complete all required fields.</button><!--<button type=\"submit\" class=\"btn btn-primary btn-block\">Save and Continue</button>--> <button ng-click=\"vm.submitForm(\'finishLater\')\" type=button class=\"btn btn-secondary btn-block\">Save and Finish Later</button><br><button ng-hide=vm.firstPassage ng-click=vm.goBack() type=button class=\"btn btn-default btn-block\">Go Back</button></form></div><nav-footer></nav-footer></div>");
$templateCache.put("app/5-conclusion/conclusion.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container><br><img src={{vm.Appcast}} style=\"display: none\" width=1px height=1px><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; color:#999\">Process Complete</div><br><div><span ng-bind-html=vm.Endtext><p></p></span></div><!--<div>\n            <p style=\"font-weight:bold; font-style:oblique; font-size:1.1em;\">Thank you, {{vm.application.firstName}} {{vm.application.lastName}}, for taking the Traitset&reg; questionnaire.</p>\n        </div>\n        <div>\n            <p style=\"font-size:1.1em;\">Please click on the \"EXIT\" button below to save your responses and either 1) continue to the final questionnaire, if any, or 2) exit the system.</p>\n        </div>--><div style=text-align:center><button ng-if=!vm.BookInfo.BookDetails.ReturnLink type=button ng-click=vm.exit() class=\"btn btn-primary\">EXIT</button> <a ng-if=vm.BookInfo.BookDetails.ReturnLink class=\"btn btn-primary\" href={{vm.BookInfo.BookDetails.ReturnLink}} class=\"btn btn-primary\">EXIT</a></div></div><!-- Begin INDEED conversion code --> <img height=1 width=1 border=0 src=\"//conv.indeed.com/pagead/conv/2353102182759202/?script=0\"><!-- End INDEED conversion code --><nav-footer></nav-footer></div>");
$templateCache.put("app/6-exit-review/exit-review.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container><br><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; color:#999\">Process Complete</div><br><div>You have completed your application/questionnaire combination. If your prospective employer wishes you to complete additional questionnaires, they will be listed below with a Take button next to them. Please complete all additional questionnaires, if any, before closing your browser<br><br>Thank you!<br><br><table width=100% cellpadding=3><tr><td bgcolor=#EEEEEE><strong>Name</strong></td><td>{{vm.application.firstName}} {{vm.application.lastName}}</td></tr><tr><td bgcolor=#EEEEEE><strong>Email</strong></td><td>{{vm.application.emailAddress}}</td></tr><tr><td bgcolor=#EEEEEE><strong>Position</strong></td><td>{{vm.application.Position.Name}}</td></tr><tr><td width=30% bgcolor=#EEEEEE><strong>PIN</strong></td><td>{{vm.application.TestTestTaker.NoUserPin}}&nbsp;</td></tr></table><br><table width=100% cellpadding=3><tr><td bgcolor=#EEEEEE><strong>Questionnaire</strong></td><td bgcolor=#EEEEEE><strong>Status</strong></td></tr><tr ng-repeat=\"(key, value) in vm.application.AllTestTakers\"><td>{{value.profile_name}}</td><td ng-show=\"value.status == \'2\'\" align=center><button class=\"btn btn-block\" disabled>Complete</button></td><td ng-show=\"value.status == \'1\'\" align=center><button type=button ng-click=vm.resume(value.no_user_pin) class=\"btn btn-primary btn-block\">Take</button></td></tr></table><br><br></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/locationFinder/locationFinder.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><div style=text-align:center><span ng-bind-html=vm.locationFormText></span><form name=application ng-submit=vm.submitForm() class=form-inline><div class=form-group><label for=zipcode>Enter Zip Code&nbsp;</label><input ng-model=vm.zipCode type=text size=8 class=form-control id=firstName placeholder=\"ZIP Code\"></div><div class=form-group><label for=radius>&nbsp;&nbsp;Search Within&nbsp;</label><select ng-model=vm.radius id=radius class=form-control><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option><option value=1000>1000</option><option value=0>All</option></select>&nbsp; miles&nbsp;&nbsp;&nbsp;</div><button type=submit class=\"btn btn-primary\">Search</button></form></div><div ng-show=vm.results><hr><span ng-bind-html=vm.locationResultsText></span><hr><table align=center width=85% cellpadding=5><tr ng-repeat=\"(k,v) in vm.locations\"><td valign=top width=55%><small><strong>{{v.CourseName}}</strong></small><br><button class=\"btn btn-sm btn-primary\" ui-sref=\"postingPage ({ \'NoCourse\': v.NoCourse, \'NoBook\': vm.NoBook, \'NoPosition\': v.NoPosition, \'r\': vm.BookId})\">Apply</button></td><td width=45%>{{v.Street}}<br>{{v.City}}, {{v.State}} {{v.Zip}}<br><small>{{v.Miles}} miles | <a href=\"http://maps.google.ca/maps?q={{v.Street}}+{{v.City}}+{{v.State}}+{{v.Zip}}\" target=_blank>View Map</a></small></td></tr></table><div>{{v}}</div></div><div ng-show=vm.error style=\"text-align:center; color:#900; font-weight:bold\"><hr><span ng-bind-html=vm.errorStr></span></div></div></div><nav-footer></nav-footer>");
$templateCache.put("app/postingDetail/postingDetail.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><br><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; color:#999\">{{vm.position.PositionDetails.Orgname}}</div><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; color:#999\">{{vm.position.PositionDetails.Locationname}}</div><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; color:#999\">{{vm.position.PositionDetails.Positionname}}</div><br><button ui-sref=\"positions({\'NoCourse\':vm.NoCourse,\'NoPosition\':vm.NoPosition})\" class=\"btn btn-sm btn-warning btn-block\">{{vm.Phrases.apply}}</button><br><div style=\"font-size:0.9em; margin-bottom:10px\"><span ng-bind-html=vm.position.PositionDetails.PostingText></span></div><br><button ui-sref=\"positions({\'NoCourse\':vm.NoCourse,\'NoPosition\':vm.NoPosition})\" class=\"btn btn-sm btn-warning btn-block\">{{vm.Phrases.apply}}</button></div><nav-footer></nav-footer></div>");
$templateCache.put("app/postingPage/postingPage.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container ng-hide=vm.loading><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; color:#999\">{{vm.BookName}}: {{vm.Phrases.openPosition}}</div><div ng-show=vm.error style=\"text-align:center; margin-top:20px\"><h4 style=color:#900>{{vm.errorStr}}</h4></div><div ng-hide=vm.error ng-repeat=\"(k,v) in vm.Positions\"><hr style=clear:both><h4 style=\"font-size:1.4em; margin:3px\">{{v.Positionname}}</h4><h5 style=\"font-size:1.1em; margin:3px\">{{v.Locationname}}</h5><p style=margin:0>{{v.Locationaddress}}</p><table align=center width=75% cellpadding=8><tr><td width=50% align=center><button ng-show=\"v.JobDescription == 1\" ui-sref=\"postingDetail({\'NoPosition\':v.NoPosition})\" class=\"btn btn-sm btn-primary btn-block\">{{vm.Phrases.jobDescription}}</button></td><td width=50% align=center><button ui-sref=\"positions({\'NoCourse\':v.Location,\'NoPosition\':v.NoPosition})\" class=\"btn btn-sm btn-warning btn-block\">{{vm.Phrases.apply}}</button></td></tr></table></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/process-deprecated/1-locations.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container><div style=text-align:center><b>Please click on the button for the<br>department you wish to apply.</b><br><br><button ui-sref=positions type=button class=\"btn btn-primary btn-block\">ABC Store # 321</button> <button ui-sref=positions type=button class=\"btn btn-primary btn-block\">ABC Store # 456</button> <button ui-sref=positions type=button class=\"btn btn-primary btn-block\">Anthony House (NTC2)</button> <button ui-sref=positions type=button class=\"btn btn-primary btn-block\">Beach Hotel</button> <button ui-sref=positions type=button class=\"btn btn-primary btn-block\">Shift Planning Demo</button> <button ui-sref=positions type=button class=\"btn btn-primary btn-block\">Fast Foods Store #789 - Saline MI</button></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/process-deprecated/2-positions.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container><div style=text-align:center><br><div style=\"font-size:1.2em; margin-top:-30px; padding:0; text-align:center; font-weight:bold\">Department / Location Name</div><div style=\"font-size:0.9em; font-weight:normal; margin-top:12px\"><b>Custom Text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam et arcu ac velit vestibulum malesuada. Nunc felis turpis, dignissim eu ornare in, aliquet eget ante.</b><br><br><button ui-sref=application type=button class=\"btn btn-primary btn-block\">Policeman</button> <button ui-sref=application type=button class=\"btn btn-primary btn-block\">Police Chief</button> <button ui-sref=application type=button class=\"btn btn-primary btn-block\">Police Commissioner</button> <button ui-sref=application type=button class=\"btn btn-primary btn-block\">Mayor</button><br><button ui-sref=locations type=button class=\"btn btn-default btn-block\">Go Back</button></div></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/process-deprecated/3-application.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container><div style=text-align:center><br><div style=\"font-size:1.2em; margin-top:-30px; padding:0; text-align:center; font-weight:bold\">Department / Location Name</div><div style=\"font-size:1.0em; padding:0; text-align:center; font-weight:bold\">Policeman</div><br><div style=\"font-size:1.3em; padding:0; text-align:center; font-weight:bold; width:100%; background-color:#369; border:1px solid #369; color:#fff\">Job Application</div><div style=\"font-size:0.9em; font-weight:normal; margin-top:12px; text-align:left; background-color:#fff; margin:5px\"><p style=padding:6px>Please complete the following information and click on the \"Save & Continue\" button at the bottom.</p><p style=\"padding:6px; background-color:#fee\"><b>Note:</b> All fields are required.<br>You may put N/A in a field if it does not apply.</p><form><div class=\"form-group col-sm-8\"><label for=firstName>First Name</label><input type=text class=form-control id=firstName placeholder=\"First Name\"></div><div class=\"form-group col-sm-4\"><label for=mi>Middle</label><input type=text class=form-control id=mi placeholder=Initial></div><div class=\"form-group col-sm-12\"><label for=lastName>Last Name</label><input type=text class=form-control id=lastName placeholder=\"Last Name\"></div><div><label>Social Security Number</label><br><div class=\"form-group col-sm-4\"><input type=number class=form-control maxlength=3 placeholder=XXX></div><div class=\"form-group col-sm-4\"><input type=number class=form-control maxlength=2 placeholder=XX></div><div class=\"form-group col-sm-4\"><input type=number class=form-control maxlength=4 placeholder=XXXX></div></div><div><label>Home Phone</label><br><div class=\"form-group col-sm-4\"><input type=number class=form-control maxlength=3 placeholder=###></div><div class=\"form-group col-sm-4\"><input type=number class=form-control maxlength=3 placeholder=###></div><div class=\"form-group col-sm-4\"><input type=number class=form-control maxlength=4 placeholder=####></div></div><div class=\"form-group col-sm-12\"><label for=emailAddress>Email Address</label><input type=text class=form-control id=emailAddress placeholder=\"Email Address\"></div><div class=\"form-group col-sm-12\"><label for=conEmailAddress>Confirm Email Address</label><input type=text class=form-control id=conEmailAddress placeholder=\"Confirm Email\"></div><div class=\"form-group col-sm-12\"><label for=streetAddress>Street</label><input type=text class=form-control id=streetAddress placeholder=\"Street Address\"></div><div class=\"form-group col-sm-12\"><label for=city>City</label><input type=text class=form-control id=city placeholder=City></div><div class=\"form-group col-sm-8\"><label for=firstName>State</label><input type=text class=form-control id=state placeholder=State></div><div class=\"form-group col-sm-4\"><label for=mi>Zip</label><input type=text class=form-control id=zip placeholder=Zip></div><div class=\"form-group col-sm-12\"><label for=referralSource>Referral Source</label><input type=text class=form-control id=referralSource placeholder=\"How did you hear about us?\"></div><button ui-sref=instructions type=button class=\"btn btn-primary btn-block\">Save and Continue</button> <button ui-sref=instructions type=button class=\"btn btn-secondary btn-block\">Save and Finish Later</button></form><br><button ui-sref=positions type=button class=\"btn btn-default btn-block\">Go Back</button></div></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/process-deprecated/4-instructions.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container><div style=text-align:center><br><div style=\"font-size:1.2em; margin-top:-30px; padding:0; text-align:center; font-weight:bold\">General Instructions</div><p style=\"text-align:left; margin-top:20px\">In answering questions, choose the number which most closely matches your feelings using the scale shown below.</p><form><hr><div style=\"text-align:left; border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><h5>Example 1:</h5><div>I like vanilla shakes.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled></td><td align=center><input type=radio name=optradio1 disabled selected checked></td><td align=center><input type=radio name=optradio1 disabled></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><h5 style=\"padding:20px; color:#090\">Means: I really do like it!</h5></div><div style=\"text-align:left; border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><h5>Example 2:</h5><div>I like lima bean ice cream.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio2 disabled selected checked></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td><td align=center><input type=radio name=optradio2 disabled></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><h5 style=\"padding:20px; color:#900\">Means: I hate it!</h5></div></form>Please click on the \"Save & Continue\" button at the bottom of each screen to save your answers.<br><br><i>Thank you!</i><p></p></div><button ui-sref=assessment type=button class=\"btn btn-primary btn-block\">Save and Continue</button> <button ui-sref=instructions type=button class=\"btn btn-secondary btn-block\">Save and Finish Later</button></div><nav-footer></nav-footer></div>");
$templateCache.put("app/process-deprecated/5-assessment.html","<div id=wrap><nav-header></nav-header><!-- Begin page content --><div class=container><div style=text-align:center><br><div style=\"font-size:1.2em; margin-top:-30px; padding:0; text-align:center; font-weight:bold\">Department / Location Name</div><div style=\"font-size:1.0em; padding:0; text-align:center; font-weight:bold\">Policeman</div><br><div style=\"font-size:1.1em; padding:0; text-align:center; font-weight:bold; width:100%; background-color:#369; border:1px solid #369; color:#fff\">Question Group 1 of 6</div><div style=\"font-size:0.9em; font-weight:normal; margin-top:12px; text-align:left; background-color:#fff; margin:5px\"><form><div style=\"border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><div>I am so dependable that people never worry about me getting the job done.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td></tr></table><table style=width:94% align=center><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><br></div><div style=\"border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><div>I would rather finish my job or task and put off personal fun because I\'ll feel better.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><br></div><div style=\"border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><div>When I give my word, people can trust me even if I later wish I didn\'t make a promise.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><br></div><div style=\"border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><div>I must admit that I have a difficult time liking or respecting people who are lazy.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><br></div><div style=\"border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><div>Work is so important that my friends have been critical of my drive or ambition.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><br></div><div style=\"border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><div>If it didn\'t ruin my plans. I would postpone my vaction to get the job done.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><br></div><div style=\"border-bottom:2px solid #ccc; padding-top:5px; font-size:1.1em; margin-bottom:12px\"><div>I have never really said any hurtful or nasty things about someone behind their back.</div><table style=width:100%><tr><td align=center>1</td><td align=center>2</td><td align=center>3</td><td align=center>4</td><td align=center>5</td><td align=center>6</td><td align=center>7</td><td align=center>8</td></tr><tr><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td><td align=center><input type=radio name=optradio></td></tr></table><table style=width:100%><tr><td style=\"padding-left:10px; font-size:11px\" align=left>Always<br>FALSE</td><td style=font-size:11px align=center>Sometimes<br>TRUE</td><td style=\"padding-right:10px; font-size:11px\" align=right>Always<br>TRUE</td></tr></table><br></div><div><button ui-sref=assessment type=button class=\"btn btn-primary btn-block\">Save and Continue</button> <button ui-sref=instructions type=button class=\"btn btn-secondary btn-block\">Save and Finish Later</button></div></form><br><button ui-sref=instructions type=button class=\"btn btn-default btn-block\">Go Back</button></div></div></div><nav-footer></nav-footer></div>");
$templateCache.put("app/process-deprecated/6-assessment-demo.html","<center style=padding-top:40px>*Deprecated*</center>");
$templateCache.put("app/sample-colors/sample-colors.html","<div ng-repeat=\"(key, value) in vm.BookInfo.Style\"><h2>{{key}}</h2><hr><ul><li ng-repeat=\"(k, v) in value\"><div style=width:200px>{{k}}</div><div ng-show=vm.dechex(v) ng-style=\"{\'background-color\': \'#{{vm.dechex(v)}}\'}\" style=\"width:300px; padding:3px; padding-left:10px; border-radius:4px\"><span style=color:#000>#{{vm.dechex(v)}} | RGB: {{v}}</span><br><span style=color:#fff>#{{vm.dechex(v)}} | RGB: {{v}}</span></div><div ng-hide=vm.dechex(v) style=\"padding:3px; padding-left:10px\">{{v}}</div></li></ul></div>");
$templateCache.put("app/components/navfooter/navfooter.html","<div id=footer style=\"width:100%; border-top:1px solid #eee; border-bottom:1px solid #eee; color:#999; text-align:center; padding-top:6px; margin-top:60px\"><b>TraitSet&reg; powered by HRgems&reg;</b><br><small>Copyright 2016 - All Rights Reserved</small></div>");
$templateCache.put("app/components/navheader/navheader.html","<nav class=\"navbar navbar-default\" role=navigation style=\"background-color:#fff !important; border:0\"><div class=navbar-header><div class=row><div class=\"col-xs-12 text-center center-block\" style=text-align:center><img src=\"https://www.traitset.com/Downloads/showimage.ashx?id={{vm.ExpImage}}\" style=\"max-width:100%; object-fit:contain\" align=center> &nbsp;</div><div class=\"col-xs-12 text-center center-block\"><div style=\"font-size:1.4em; text-align:center; margin:0 auto; margin-top:10px; padding:0; font-weight:bold\">{{vm.CompanyName}}</div></div><!--             <div class=\"row\"> --><!--                 <div class=\"col-xs-3 offset-1 text-center center-block\"> --><!--                     Select Language: --><!--                 </div> --><!--                 <div class=\"col-xs-3 text-center center-block\"> --><!--                     <form> --><!--                         <select class=\"form-control\" ng-model=\"vm.languageOption\" ng-change=\"vm.newLanguage(vm.languageOption)\"> --><!--                             <option value=\"\"></option> --><!--                             <option value=\"2\">French</option> --><!--                             <option value=\"1\">English</option> --><!--                         </select> --><!--                     </form> --><!--                 </div> --><!--             </div> --></div></div></nav>");}]);